import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Entity, EntityCreate } from "@/model";
import entityRepository from "@/repository/entityRepository";
import { entityQueryKeys } from "./keys";


export const useCreateEntity = (agentId: number) => {
    const queryClient = useQueryClient();

    return useMutation<Entity, AxiosError, EntityCreate>({
        mutationKey: ["entity", "create", agentId],
        mutationFn: async (body: EntityCreate) => {
            try {
                const { data } = await entityRepository.create(body);
                return data.result;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: entityQueryKeys.recent(agentId),
                exact: false
            });
            await queryClient.invalidateQueries({
                queryKey: entityQueryKeys.pageAll(agentId)
            });
        }
    });
};
